import { FeatureLabel } from './FeaturedLabel'
import { ArticleCommon } from '../../../types'
import { css } from '@emotion/react'
import { mq, colors, breakpoint } from 'plume-ui'
import { ArticleCard } from './ArticleCard'

type Props = {
  articles?: ArticleCommon[]
  className?: string
}

export const RecommendedArticleList: React.FC<Props> = (props) => {
  if (!props.articles) {
    return null
  }

  return (
    <>
      <div
        css={css`
          ${mq.large} {
            background-color: ${colors.gray40};
          }
        `}
        className={props.className}
      >
        <div
          css={css`
            max-width: ${breakpoint.extraLarge}px;
            margin: 0 auto;
            padding-block: 24px 8px;
            padding-inline: 24px;
            ${mq.large} {
              padding-block: 64px 16px;
              padding-inline: 0;
            }
          `}
        >
          <FeatureLabel>おすすめ記事</FeatureLabel>
        </div>
        <div
          css={css`
            margin: 0;
            padding: 0;
            display: grid;
            grid-template-columns: 1fr;
            max-width: ${breakpoint.extraLarge}px;
            margin-inline: auto;
            ${mq.large} {
              grid-template-columns: repeat(3, 1fr);
              gap: 32px;
              padding-block-end: 64px;
            }
          `}
        >
          {props.articles.map((article) => (
            <ArticleCard
              className="article-card"
              article={article}
              key={article.id}
            />
          ))}
        </div>
      </div>
    </>
  )
}
